export const getOnlyNumber = (val: string) => val.replace(/[^0-9]/g, '')
